module.exports = __webpack_public_path__ + "img/hero.7ed134c0.svg";